import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hour4u-admin-enterprise-admin',
  templateUrl: './enterprise-admin.component.html',
  styleUrls: ['./enterprise-admin.component.scss']
})
export class EnterpriseAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
